import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import FormErrors from "@/components/FormErrors/FormErrors.vue";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { JSConn } from "@/utilities/js-conn";
import { format } from "date-fns";

import { buildSubmitButton, buildFormErrors } from "@/utilities/form-helpers";
import { buildFormClientFieldAutocomplete } from "@/models/ClientField";
import { buildFormTemplateWorkOrderAutocomplete } from "@/models/TemplateWorkOrder";
import { NamedRts } from "@/router";
import AutocompleteId from "@/components/Autocomplete/AutocompleteId.vue";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

import { buildFormCreateWorkOrder } from "@/models/WorkOrder";

export default defineComponent({
  name: "createWorkOrderForm",
  components: {
    FormErrors,
    AutocompleteId,
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Preparing the form...");

    let { hasFormErrors, formErrors } = buildFormErrors();

    let firstInput: any = ref(null);

    const cancelParams = () => {
      return {
        name: NamedRts.workOrders,
      };
    };

    let { formCreateWorkOrder } = buildFormCreateWorkOrder();

    let { submitButtonText, submitting } = buildSubmitButton();

    onMounted(() => {
      const jsConn = new JSConn();
      const jsConnTemplateWorkOrders = new JSConn();
      const dataPromises = [
        $store.dispatch("needClientFields", jsConn),
        $store.dispatch("needTemplateWorkOrders", jsConnTemplateWorkOrders),
      ];

      Promise.all(dataPromises).then(() => {
        dataLoaded.value = true;
        return Promise.resolve();
      });
    });

    const onSubmit = (evt: any) => {
      evt.preventDefault();
      const jsConn = new JSConn();
      const td = format(new Date(), "yyyy-MM-dd");

      jsConn.formParams = {
        client_field_id: formCreateWorkOrder.client_field_id,
        template_id: formCreateWorkOrder.template_id,
        submitted_date: td,
      };

      $store.dispatch("createWorkOrderFromTemplate", jsConn).then(() => {
        ctx.root.$router.push({
          name: "workOrders",
        });
        return Promise.resolve();
      });
    };

    let { updateClientField } = buildFormClientFieldAutocomplete();
    let { updateTemplateWorkOrder } = buildFormTemplateWorkOrderAutocomplete();

    const localUpdateClientField = (evt: AutocompleteResult) => {
      updateClientField(
        evt,
        formCreateWorkOrder.formClientField,
        formCreateWorkOrder,
      );
    };

    const localUpdateTemplateWorkOrder = (evt: AutocompleteResult) => {
      updateTemplateWorkOrder(
        evt,
        formCreateWorkOrder.formTemplateWorkOrder,
        formCreateWorkOrder,
      );
    };

    const clientFieldsForAutocomplete = computed(() => {
      return $store.getters.clientFieldsForAutocomplete;
    });

    const templateWorkOrdersForAutocomplete = computed(() => {
      return $store.getters.templateWorkOrdersForAutocomplete;
    });

    return {
      dataLoaded,
      loadingMessage,
      firstInput,
      hasFormErrors,
      formErrors,

      submitButtonText,
      submitting,
      onSubmit,

      cancelParams,

      formCreateWorkOrder,
      localUpdateClientField,
      localUpdateTemplateWorkOrder,

      clientFieldsForAutocomplete,
      templateWorkOrdersForAutocomplete,
    };
  },
});
